export default {
  offset: {
    top: 40,
    right: 40,
    bottom: 40,
    left: 40,
  },
  scheme: {
    count: 4,
    styles: {
      width: 2,
      color: '#2b2a49'
    }
  },
  labels: {
    enable: true,
    offset: 15,
    styles: {
      fontSize: 14,
      color: '#ffffff'
    }
  },
  data: {
    line: {
      styles: {
        width: 2
      }
    },
    dots: {
      enable: true,
      styles: {
        width: 3,
        hover: {
          width: 5
        }
      },
    }
  }
};
